"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

/**
 * base class for a JBrowse plugin
 */
var Plugin = /*#__PURE__*/function () {
  function Plugin() {
    (0, _classCallCheck2.default)(this, Plugin);
    (0, _defineProperty2.default)(this, "name", void 0);
    (0, _defineProperty2.default)(this, "url", void 0);
    (0, _defineProperty2.default)(this, "version", void 0);
    (0, _defineProperty2.default)(this, "configurationSchema", undefined);
  }

  (0, _createClass2.default)(Plugin, [{
    key: "install",
    value: function install(_pluginManager) {}
  }, {
    key: "configure",
    value: function configure(_pluginManager) {}
  }]);
  return Plugin;
}();

exports.default = Plugin;